import DescRegistroService from 'src/modules/descRegistro/descRegistroService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'DESCREGISTRO_VIEW';

const descRegistroViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: descRegistroViewActions.FIND_STARTED,
      });

      const record = await DescRegistroService.find(id);

      dispatch({
        type: descRegistroViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: descRegistroViewActions.FIND_ERROR,
      });

      getHistory().push('/desc-registro');
    }
  },
};

export default descRegistroViewActions;
